import { Box, Button, Theme, Typography } from '@mui/material'

import { AppContainer } from '@shared/components/AppContainer';
import { useEffect } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';

import { TokenOverview } from '@shared/components/TokenOverview';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getTokenAction, resetToken, tokenSelector } from '@store/slices/token.slice';

import { makeStyles } from '@mui/styles';
import styles from './styles';

const useStyles = makeStyles((theme) => (styles(theme)));

export const BusinessToken = () => {
    const tokenDetails = useAppSelector(tokenSelector);
    const dispatch = useAppDispatch();
    let { id } = useParams<{ id: string }>();

    useEffect(() => {
        dispatch(resetToken())
        if (id) {
            dispatch(getTokenAction(id))
        }
    }, [])

    return (
        <AppContainer>
            <TokenOverview token={tokenDetails?.token}>
                <Box my={2} >
                    <Button variant="contained"
                        className={'button w-100'}
                        size="large"
                        color="primary"
                        component={RouterLink}
                        to={`/token/edit/${tokenDetails.token?.id}`}
                    >
                        <Typography className={'button-label'}>
                            Edit
                        </Typography>
                    </Button>
                </Box>
            </TokenOverview>
        </AppContainer>
    )
}
